<template>
  <advanced-table
    :headers="headers"
    :filters="filters"
    :sortBy="['created']"
    :sortDesc="[true]"
    :resource="resource"
    :optionLists="optionLists"
  />
</template>

<script>
import AdvancedTable from "@/components/AdvancedTable.vue";

export default {
  data() {
    return {
      clickedImei: null,
      headers: [
        {
          text: "שם",
          value: "name",
          align: "start",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            return data[key] ? data[key] : "ללא שם";
          },
          linkTo: item => {
            return `/customers/${item._id}`;
          }
        },
        {
          text: "תעודת זהות",
          value: "id",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            return data[key] ? data[key] : "ללא תעודת זהות";
          }
        },
        {
          text: "טלפון",
          value: "phone",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            return data[key] ? data[key] : "ללא טלפון";
          }
        },
        {
          text: "אי-מייל",
          value: "email",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            return data[key] ? data[key] : "ללא אי-מייל";
          }
        },
        {
          text: "תאריך יצירה",
          value: "created",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            return data[key] ? this.heDate(data[key]) : "לא ידוע";
          }
        }
      ],
      filters: [
        {
          type: "DATE",
          label: "נוצר אחרי",
          model: "createdAfter",
          active: false
        },
        {
          type: "DATE",
          label: "נוצר לפני",
          model: "createdBefore",
          active: false
        },
        {
          type: "TEXT",
          label: "חיפוש",
          model: "search",
          icon: "mdi-magnify",
          expanded: true,
          active: true
        }
      ]
    };
  },
  computed: {
    resource() {
      return this.$store.state.resources["customer"];
    },
    optionLists() {
      return {};
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    }
  },
  methods: {
    entityById(entityType, id) {
      return this.$store.getters["entity"](entityType, id);
    },
    heDate(d) {
      let date = new Date(d);
      let options = { weekday: "long", month: "long", day: "numeric" };
      return new Intl.DateTimeFormat("he-IL", options).format(date);
    }
  },

  watch: {},

  components: {
    AdvancedTable
  }
};
</script>